if (!customElements.get('platform-select')) {
  class PlatformSelect extends HTMLElement {

    constructor() {
      super();
      this.frameWrapper = this.querySelector('.platform-select-frame-wrapper');
      this.frameId = this.getAttribute('data-frame-id');

      if (!this.frameWrapper) {
        this.frameWrapper = document.querySelector(`.platform-select-frame-wrapper[data-frame-id=${this.getAttribute('data-frame-id')}]`);
        // if (!this.frameWrapper) return;
      }

      this.addEventListener('click', (event) => {
        this.setFramePosition();
        this.frameWrapper.classList.toggle('active');
      });

      this.querySelector('.platform-select__close')?.addEventListener('click', () => {
        this.frameWrapper.classList.remove('active');
      });
      this.moveFrameToBody();


      let isMouseOverThis = false;
      let isMouseOverFrame = false;
      this.addEventListener('mouseenter', () => {
        isMouseOverThis = true;
        this.setFramePosition();
      });
      this.addEventListener('mouseleave', () => {
        isMouseOverThis = false;
      });
      this.frameWrapper.addEventListener('mouseenter', () => {
        isMouseOverFrame = true;
        if (isMouseOverThis || isMouseOverFrame) {
          this.frameWrapper.classList.add('active');
        }
      });
      this.frameWrapper.addEventListener('mouseleave', () => {
        isMouseOverFrame = false;
      });

      window.addEventListener('scroll', (event) => {
        if (this.frameWrapper.classList.contains('active')) {
          this.setFramePosition();
        }
      });

      document.addEventListener('click', (event) => {
        if (!isMouseOverThis && !isMouseOverFrame) {
          this.frameWrapper.classList.remove('active');
        }
      });
    }

    setFramePosition() {
      const bounding = this.getBoundingClientRect();
      const positionX = bounding.left;
      const positionY = bounding.top + bounding.height;
      this.frameWrapper.style.setProperty('--position-x', positionX + 'px');
      this.frameWrapper.style.setProperty('--position-y', positionY + 'px');
    }

    moveFrameToBody() {
      document.body.append(this.frameWrapper);
    }

    moveFrameToThis() {
      this.append(this.frameWrapper);
    }
  }

  customElements.define('platform-select', PlatformSelect);
}